
























import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {INetworkProfileService} from '@/services/network/INetworkProfileService';

import NetworkProfilesList from '@/components/Networking/Profile/NetworkProfilesList.vue';
import NetworkProfilesStore from '@/store/network/NetworkProfiles.store';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {NetworkProfilesList},
})
export default class NetworkProfiles extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('INetworkProfileService'))
  private profileService!: INetworkProfileService;

  private profilesStore: NetworkProfilesStore = getModule(NetworkProfilesStore, this.$store);

  private refreshing: boolean = false;

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.logger.debug(`Refreshing data...`);
    this.refreshing = true;

    try {
      this.logger.debug(`Fetching network profiles`);
      await this.profilesStore.fetchProfiles(true);
      this.logger.debug(`Network profiles fetched`, this.profilesStore.Profiles);

    } catch (error) {
      Notify.Error(this.logger, `Could no get network interfaces`, error);
    } finally {
      this.refreshing = false;
    }
  }
}
